import { RecordByPrimaryKey } from "@pdfking/templates"

import type { Meta3DAnimation } from "#internal"

export const Meta3DAnimationList = RecordByPrimaryKey<Meta3DAnimation>([
  { id: "normal", name: "Book" },
  { id: "stripe", name: "Stripe" },
] as const)
